import React from 'react';
import { Content } from "./Content";
import { Box } from '@applyboard/crystal-ui';
export var PathwayPage = function PathwayPage() {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Content, null));
};